import { z } from 'zod';

// Both durations are in seconds. A generous floor keeps generated fixtures from
// looking already-expired to the proactive refresh check (which looks ~60s ahead).
const MIN_ACCESS_TOKEN_EXPIRES_IN_S = 300;
const MAX_ACCESS_TOKEN_EXPIRES_IN_S = 1800;
const MIN_REFRESH_TOKEN_EXPIRES_IN_S = 3600;
const MAX_REFRESH_TOKEN_EXPIRES_IN_S = 14400;

export const tokenFieldsSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  accessTokenExpiresAt: z.string(),
  refreshTokenExpiresAt: z.string(),
  accessTokenExpiresIn: z
    .number()
    .int()
    .min(MIN_ACCESS_TOKEN_EXPIRES_IN_S)
    .max(MAX_ACCESS_TOKEN_EXPIRES_IN_S),
  refreshTokenExpiresIn: z
    .number()
    .int()
    .min(MIN_REFRESH_TOKEN_EXPIRES_IN_S)
    .max(MAX_REFRESH_TOKEN_EXPIRES_IN_S),
});

export const tokenRefreshSchema = tokenFieldsSchema;
